<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <div class="plans-company">
      <h2>Administrador da Empresa</h2>
      <form
        class="content-plans-register-form"
        @submit.prevent="handleSubmit()"
      >
        <div class="row">
          <div class="col-12">
            <div class="content-input-default">
              <label for="name">Nome do administrador:</label>
              <input
                id="name"
                type="text"
                name="name_admin"
                v-model="companyAdmin.name"
                value=""
                placeholder="Nome"
                required
              />
            </div>
          </div>
          <div class="col-12">
            <div class="content-input-default-select">
              <label for="type-email">Qual o provedor do e-mail?</label>
              <div class="position-relative">
                <select
                  id="type-email"
                  v-model="companyAdmin.email_provider"
                  aria-label="department-company"
                  :class="{
                    'content-input-default-select--active':
                      companyAdmin.email_provider !== '',
                  }"
                  required
                >
                  <option value="" selected>
                    Selecione o provedor do e-mail*
                  </option>
                  <option
                    v-for="email in typesEmail"
                    :key="email.id"
                    :name="email.name"
                    :value="email.id"
                  >
                    {{ email.name }}
                  </option>
                </select>
                <svg
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_35_1490"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="7"
                    height="12"
                    style="mask-type: luminance"
                  >
                    <path
                      d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                      fill="white"
                    ></path>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                    <path
                      d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                      fill="black"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <template v-if="companyAdmin.email_provider !== ''">
            <div class="col-12">
              <div class="content-input-default">
                <label for="email">E-mail administrador:</label>
                <input
                  id="email"
                  type="email"
                  name="email_admin"
                  v-model="companyAdmin.email"
                  value=""
                  placeholder="Ex: kelvin@alphasoftwaresapps.com"
                  required
                />
              </div>
            </div>
            <div v-if="companyAdmin.email_provider !== 'google'" class="col-12">
              <div class="content-input-default">
                <p v-if="companyAdmin.has_password" class="password-registred">
                  Senha já cadastrada.
                </p>
                <label for="temporary-password">{{
                  companyAdmin.has_password
                    ? "Nova senha temporária (opcional):"
                    : "Senha temporária:"
                }}</label>
                <div class="position-relative">
                  <input
                    id="temporary-password"
                    v-model="temporaryPassword"
                    type="password"
                    name="temporary_password"
                    autocomplete="new-password"
                    minlength="8"
                    maxlength="128"
                    :required="!companyAdmin.has_password"
                    aria-describedby="password-help"
                  />
                  <button
                    class="btn-show-password"
                    type="button"
                    @click="handleClickShowTemporaryPassword"
                  >
                    <template v-if="showTemporaryPassword">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                      >
                        <path
                          d="M320 96C239.2 96 174.5 132.8 127.4 176.6C80.6 220.1 49.3 272 34.4 307.7C31.1 315.6 31.1 324.4 34.4 332.3C49.3 368 80.6 420 127.4 463.4C174.5 507.1 239.2 544 320 544C400.8 544 465.5 507.2 512.6 463.4C559.4 419.9 590.7 368 605.6 332.3C608.9 324.4 608.9 315.6 605.6 307.7C590.7 272 559.4 220 512.6 176.6C465.5 132.9 400.8 96 320 96zM176 320C176 240.5 240.5 176 320 176C399.5 176 464 240.5 464 320C464 399.5 399.5 464 320 464C240.5 464 176 399.5 176 320zM320 256C320 291.3 291.3 320 256 320C244.5 320 233.7 317 224.3 311.6C223.3 322.5 224.2 333.7 227.2 344.8C240.9 396 293.6 426.4 344.8 412.7C396 399 426.4 346.3 412.7 295.1C400.5 249.4 357.2 220.3 311.6 224.3C316.9 233.6 320 244.4 320 256z"
                        />
                      </svg>
                    </template>
                    <template v-else>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                      >
                        <path
                          d="M73 39.1C63.6 29.7 48.4 29.7 39.1 39.1C29.8 48.5 29.7 63.7 39 73.1L567 601.1C576.4 610.5 591.6 610.5 600.9 601.1C610.2 591.7 610.3 576.5 600.9 567.2L504.5 470.8C507.2 468.4 509.9 466 512.5 463.6C559.3 420.1 590.6 368.2 605.5 332.5C608.8 324.6 608.8 315.8 605.5 307.9C590.6 272.2 559.3 220.2 512.5 176.8C465.4 133.1 400.7 96.2 319.9 96.2C263.1 96.2 214.3 114.4 173.9 140.4L73 39.1zM236.5 202.7C260 185.9 288.9 176 320 176C399.5 176 464 240.5 464 320C464 351.1 454.1 379.9 437.3 403.5L402.6 368.8C415.3 347.4 419.6 321.1 412.7 295.1C399 243.9 346.3 213.5 295.1 227.2C286.5 229.5 278.4 232.9 271.1 237.2L236.4 202.5zM357.3 459.1C345.4 462.3 332.9 464 320 464C240.5 464 176 399.5 176 320C176 307.1 177.7 294.6 180.9 282.7L101.4 203.2C68.8 240 46.4 279 34.5 307.7C31.2 315.6 31.2 324.4 34.5 332.3C49.4 368 80.7 420 127.5 463.4C174.6 507.1 239.3 544 320.1 544C357.4 544 391.3 536.1 421.6 523.4L357.4 459.2z"
                        />
                      </svg>
                    </template>
                  </button>
                </div>
                <span id="password-help"
                  >{{
                    companyAdmin.has_password
                      ? "Por segurança, a senha atual não é exibida. Deixe em branco para mantê-la. Preencha apenas para substituí-la."
                      : "Defina uma senha para habilitar o acesso por e-mail e senha."
                  }}
                  Mínimo de 8 caracteres. Compartilhe a nova senha por um canal
                  seguro.</span
                >
              </div>
            </div>
            <div class="col-12">
              <div class="content-input-default-select">
                <label for="department">Departamento do administrador:</label>
                <div class="position-relative">
                  <select
                    id="department"
                    v-model="companyAdmin.id_departments"
                    aria-label="department-company"
                    :class="{
                      'content-input-default-select--active':
                        companyAdmin.id_departments !== '',
                      'content-input-default-select--disabled':
                        companyAdmin.is_active,
                    }"
                    required
                  >
                    <option value="" selected>
                      Selecione o departamento do administrador*
                    </option>
                    <option
                      v-for="department in departments"
                      :key="department.id"
                      :name="`department-${department.id}`"
                      :value="department.id"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                  <svg
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_35_1490"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="7"
                      height="12"
                      style="mask-type: luminance"
                    >
                      <path
                        d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                        fill="white"
                      ></path>
                    </mask>
                    <g mask="url(#mask0_35_1490)">
                      <path
                        d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                        fill="black"
                      ></path>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="col-12">
              <button class="btn-green">Salvar</button>
            </div>
          </template>
        </div>
      </form>
      <div class="navbar-register">
        <button
          v-if="$route.name === 'EditAdminCompany'"
          class="btn-send-email"
          @click="handleClickResendEmail"
        >
          Reenviar e-mail de acesso
        </button>
        <div class="content-switch">
          <div class="content-switch__div">
            <p class="content-switch__text">
              <template v-if="companyAdmin.is_active"> Desativar </template>
              <template v-else> Ativar </template>
              admin?
            </p>
            <label class="switch">
              <input
                type="checkbox"
                name="is_active"
                v-model="companyAdmin.is_active"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
        {
          name: "Administradores",
          routerName: "ListAdminsCompany",
        },
        {
          name: "Configurar Administrador",
          routerName: "RegisterAdminCompany",
        },
      ],
      companyAdmin: {
        id_company: "",
        id_departments: "",
        name: "",
        email: "",
        is_active: false,
        email_provider: "",
        has_password: false,
      },
      dataProps: { module: "Company" },
      typesEmail: [
        { id: "google", name: "Google" },
        { id: "outlook", name: "Outlook" },
        { id: "hotmail", name: "Hotmail" },
        { id: "yahoo", name: "Yahoo" },
        { id: "outro", name: "Outro" },
      ],
      temporaryPassword: "",
      showTemporaryPassword: false,
    };
  },
  computed: {
    ...mapGetters({
      departments: "Company/departments",
      companyAdminsData: "Company/companyAdmins",
    }),
    hasParamsIdCompanyAdmin() {
      return (
        Object.keys(this.$route?.params).length > 0 &&
        this.$route.params.idCompanyAdmin
      );
    },
    hasCompanyAdmin() {
      return (
        this.companyAdminsData && Object.keys(this.companyAdminsData).length > 0
      );
    },
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Company", [
      "registerCompanyAdmin",
      "consultCompanyAdmins",
      "consultDepartments",
      "resendEmailRegisterCompanyAdmin",
    ]),
    async handleSubmit() {
      let message = this.companyAdmin?.id
        ? "Administrador da empresa editado com sucesso!"
        : "Administrador da empresa cadastrado com sucesso!";

      this.companyAdmin.id_company = this.$route.params.id;
      const account = { ...this.companyAdmin };
      delete account.has_password;
      delete account.temporary_password;
      await this.registerCompanyAdmin({
        ...account,
        ...(account.email_provider !== "google" && this.temporaryPassword
          ? { temporary_password: this.temporaryPassword }
          : {}),
      });
      this.temporaryPassword = "";
      this.$swal.fire({
        icon: "success",
        html: message,
      });
      this.$router.push({
        name: "ListAdminsCompany",
        params: {
          id: this.$route.params.id,
          slug: this.$route.params.slug,
        },
      });
    },
    handleDataBreadcrumb() {
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
      this.links[2].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
      this.links[3].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
    },
    async handleClickResendEmail() {
      const { data } = await this.resendEmailRegisterCompanyAdmin({
        id_company: this.$route.params.id,
        id: this.$route.params.idCompanyAdmin,
      });

      if (data.success) {
        this.$swal.fire({
          icon: "success",
          html: this.companyAdmin.has_password
            ? "E-mail enviado com uma nova senha temporária. A senha anterior foi substituída."
            : "E-mail de acesso à plataforma enviado com sucesso!",
        });
      }
    },
    handleClickShowTemporaryPassword() {
      this.showTemporaryPassword = !this.showTemporaryPassword;
      const input = document.getElementById("temporary-password");
      if (input) {
        input.type = this.showTemporaryPassword ? "text" : "password";
      }
    },
  },
  async mounted() {
    await this.consultDepartments();
    this.handleDataBreadcrumb();

    if (this.hasParamsIdCompanyAdmin) {
      await this.consultCompanyAdmins(this.$route.params);
      if (this.hasCompanyAdmin) {
        this.companyAdmin = { ...this.companyAdminsData };
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
  h2 {
    font-size: 24px;
    font-family: "Font Semibold";
    color: var(--black);
    text-align: left;
    margin-bottom: 50px;
  }
  .plans-company {
    position: relative;
    .content-switch {
      position: absolute;
      top: 30px;
      right: 0;
      &__div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      &__text {
        font-size: 12px;
        font-family: "Font Light";
        color: var(--black);
        margin-right: 10px;
        margin-bottom: 0;
        &-disabled {
          font-size: 10px;
          font-family: "Font Light";
          color: var(--black);
          margin-top: 5px;
          margin-bottom: 0;
        }
      }
      .switch {
        position: relative;
        display: inline-block;
        width: 51px;
        height: 26px;
        margin-bottom: 0;
      }
      /* Hide default HTML checkbox */
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      /* The slider */
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--red-dark);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 3px;
        bottom: 3px;
        background-color: var(--white);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      input:checked + .slider {
        background-color: var(--green);
      }
      input:checked + .slider:before {
        -webkit-transform: translateX(25px);
        -ms-transform: translateX(25px);
        transform: translateX(25px);
      }
      /* Rounded sliders */
      .slider.round {
        border-radius: 20px;
      }
      .slider.round:before {
        border-radius: 100%;
      }
    }
  }
  .navbar-register {
    position: absolute;
    top: 30px;
    right: 0;
    display: flex;
    align-items: center;
    gap: 0 20px;
    @media (max-width: 991px) {
      gap: 0 10px;
      margin-top: 10px;
    }
    .btn-send-email {
      font-size: 16px;
      font-family: "Font Semibold";
      color: var(--white);
      background: linear-gradient(to bottom, var(--green), var(--green-dark));
      border: none;
      border-radius: 30px;
      padding: 5px 15px;
      @media (max-width: 991px) {
        font-size: 10px;
        padding: 5px 10px;
      }
    }
    .content-switch {
      position: relative;
      top: initial;
      right: initial;
    }
  }
  .password-registred {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    border: 1px solid #a7d7b8;
    border-radius: 8px;
    background-color: #edf8f0;
    color: #205c37;
    font-size: 13px;
    font-family: "Font Semibold";
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 12px;
  }
  .btn-show-password {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    svg {
      width: 20px;
      height: 20px;
      fill: var(--black);
      @media (max-width: 991px) {
        width: 15px;
        height: 15px;
      }
    }
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
